module.exports = __webpack_public_path__ + "img/info-square-fill.cd991a4d.svg";